import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'visitor-desktop-clients',
  templateUrl: './desktop-clients.component.html',
  styleUrls: ['./desktop-clients.component.css']
})
export class DesktopClientsComponent implements OnInit {

  public images1: any[]
  public images2: any[]
  
  constructor() { 
    this.images1 = [
      {url: '../../../../../assets/clients/Espacio click.svg'},
      {url: '../../../../../assets/clients/Panel.svg'},
      {url: '../../../../../assets/clients/cotalker 1.svg'},
      
    ]

    this.images2 = [
      {url: '../../../../../assets/clients/Tiket.svg'},
      {url: '../../../../../assets/clients/minkai.svg'},
    ]
  }

  ngOnInit(): void {
  }

}
